import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { getEnv } from '@suite/shared';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private static initialized = false;

  static init(): void {
    const key = getEnv('posthogKey');
    const host = getEnv('posthogHost');

    if (!key || !host) {
      console.warn('[Analytics] PostHog key or host not configured');
      return;
    }

    if (AnalyticsService.initialized) {
      return;
    }

    posthog.init(key, {
      api_host: host,
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      capture_exceptions: true,
    });

    AnalyticsService.initialized = true;
  }

  trackEvent(name: string, properties?: Record<string, unknown>): void {
    if (!AnalyticsService.initialized) return;
    posthog.capture(name, properties);
  }

  identify(userId: string, properties?: Record<string, unknown>): void {
    if (!AnalyticsService.initialized) return;
    posthog.identify(userId, properties);
  }

  reset(): void {
    if (!AnalyticsService.initialized) return;
    posthog.reset();
  }

  captureException(error: Error, properties?: Record<string, unknown>): void {
    if (!AnalyticsService.initialized) return;
    posthog.captureException(error, properties);
  }
}
